import DeptPage from "@/pages/zones/DeptPage";
import { departmentsData } from "@/mocks/departments";

export default function SeineEtMarne77Page() {
  return <DeptPage dept={departmentsData["seine-et-marne-77"]} />;
}
